export interface LibraryTask {
  name: string;
  emoji: string;
  baseReward: number;
  xp: number;
}

export interface LibraryCategory {
  category: string;
  categoryEmoji: string;
  tasks: LibraryTask[];
}

export const TASK_LIBRARY: LibraryCategory[] = [
  {
    category: "Morning Routine",
    categoryEmoji: "☀️",
    tasks: [
      { name: "Brush Teeth",  emoji: "🦷", baseReward: 5,  xp: 10 },
      { name: "Make Bed",     emoji: "🛏️", baseReward: 5,  xp: 10 },
      { name: "Eat Breakfast",emoji: "🥣", baseReward: 5,  xp: 10 },
      { name: "Get Dressed",  emoji: "👕", baseReward: 5,  xp: 10 },
    ],
  },
  {
    category: "Home Chores",
    categoryEmoji: "🏠",
    tasks: [
      { name: "Take Out Trash",   emoji: "🗑️", baseReward: 10, xp: 20 },
      { name: "Put Dishes Away",  emoji: "🍽️", baseReward: 8,  xp: 15 },
      { name: "Clean Room",       emoji: "🧹", baseReward: 15, xp: 30 },
      { name: "Do Laundry",       emoji: "🧺", baseReward: 12, xp: 25 },
      { name: "Clean Bathroom",   emoji: "🧽", baseReward: 15, xp: 30 },
      { name: "Tidy Living Room", emoji: "🧴", baseReward: 10, xp: 20 },
    ],
  },
  {
    category: "School",
    categoryEmoji: "📚",
    tasks: [
      { name: "Do Homework",     emoji: "📝", baseReward: 15, xp: 30 },
      { name: "Read 20 Minutes", emoji: "📖", baseReward: 10, xp: 20 },
      { name: "Pack School Bag", emoji: "🎒", baseReward: 5,  xp: 10 },
    ],
  },
  {
    category: "Outside",
    categoryEmoji: "🌿",
    tasks: [
      { name: "Walk the Dog",       emoji: "🐕", baseReward: 10, xp: 20 },
      { name: "Water Plants",       emoji: "🌱", baseReward: 8,  xp: 15 },
      { name: "Take Out Recycling", emoji: "♻️", baseReward: 8,  xp: 15 },
    ],
  },
  {
    category: "Personal",
    categoryEmoji: "💪",
    tasks: [
      { name: "Shower/Bath",         emoji: "🚿", baseReward: 8,  xp: 15 },
      { name: "Exercise 15 Minutes", emoji: "💪", baseReward: 10, xp: 20 },
    ],
  },
];
